import { default as userStore } from './UserStore'
import { default as bookingStore } from './BookingStore'
import { default as golfCourseStore } from './GolfCourseStore'
import { default as datesStore } from './DatesStore'
import { default as configStore } from './ConfigStore'
import { default as partnersStore } from './PartnersStore'
import { default as blogStore } from './BlogStore'
import { default as residenceBookingStore } from './ResidenceBookingStore'
import { default as adminStore } from './AdminStore'
import { default as utilStore } from './UtilStore'
import { default as modalStore } from './ModalStore'
import { default as tournamentStore } from './TournamentStore'
import { default as partnerInformationStore } from './PartnerInformationStore'
import { default as translationStore } from './TranslationStore'
import { default as mediaStore } from './MediaStore'

export default {
    userStore,
    bookingStore,
    residenceBookingStore,
    golfCourseStore,
    datesStore,
    configStore,
    partnersStore,
    blogStore,
    adminStore,
    utilStore,
    modalStore,
    tournamentStore,
    partnerInformationStore,
    translationStore,
    mediaStore,
}



// WEBPACK FOOTER //
// /src/stores/index.js